<script>
  export let btnExport = false;
  export let placeholder;
  export let value;

  let inputSearch;
  export let onAction;

  export let handleInput = (e) => {
    value = e.target.value;
  };
  export let exportPrefix = '';
  export let exportText = 'Export';
  export let comeFrom = '';
  export let isManagerView = false;
</script>

<div class="d-flex flex-wrap flex-row justify-content-end right-action-btn position-relative">
  <div class="input-block-search position-relative">
    {#if value && value != ''}
      <img
        alt=""
        src="/images/cross.svg"
        class="cursor"
        on:click={(e) => {
          value = '';
          handleInput({ target: { value: '' } });
        }}
      />
    {:else}
      <img
        alt=""
        src="/images/search.svg"
      />
    {/if}
    <input
      bind:this={inputSearch}
      on:input={handleInput}
      value={value}
      placeholder={placeholder || 'Search'}
      class="mb-0 form-control input-manager-view"
      type="text"
    />
  </div>

  {#if btnExport == true}
    {#if comeFrom == 'taskList'}
      <button
        on:click={() => onAction('export')}
        class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
      >
        <svg
          class="me-1 icon-16"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
          ><g
            ><g
              ><path
                d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
              /></g
            ></g
          ><g
            ><g
              ><path
                d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
              /></g
            ></g
          ></svg
        >
        Basic Export
      </button>
      <button
        on:click={() => onAction('exportsubtask')}
        class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
      >
        <svg
          class="me-1 icon-16"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
          ><g
            ><g
              ><path
                d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
              /></g
            ></g
          ><g
            ><g
              ><path
                d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
              /></g
            ></g
          ></svg
        >
        Detailed Export
      </button>
      <button
        on:click={() => onAction('exportcollabrator')}
        class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
      >
        <svg
          class="me-1 icon-16"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
          ><g
            ><g
              ><path
                d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
              /></g
            ></g
          ><g
            ><g
              ><path
                d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
              /></g
            ></g
          ></svg
        >
        Collaboration Export
      </button>
    {:else}
      {#if exportPrefix != ''}<span
          class="mb-0 ms-2 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
          >{exportPrefix}</span
        >{/if}<button
        on:click={() => onAction('export')}
        class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
      >
        <svg
          class="me-1 icon-16"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
          ><g
            ><g
              ><path
                d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
              /></g
            ></g
          ><g
            ><g
              ><path
                d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
              /></g
            ></g
          ></svg
        >
        {exportText}
      </button>
    {/if}
  {/if}
</div>

<style lang="scss">
  .btn-export {
    &:hover {
      color: $blue-color;
      svg {
        fill: $blue-color;
      }
    }
  }
</style>
